/**
 * Was beim Namensanbieter (etwa 1blu) ins Feld „Host“ gehört.
 *
 * Die Anbieter erwarten dort nur den Teil vor der Domain: für die Domain selbst
 * bleibt das Feld leer oder bekommt `@`, für `_dmarc.beispiel.de` steht dort `_dmarc`.
 */
export function dnsHost(recordName: string, domain: string): string | null {
  const name = normalize(recordName);
  const zone = normalize(domain);
  if (name === zone) return null;
  const suffix = `.${zone}`;
  return name.endsWith(suffix) ? name.slice(0, -suffix.length) : name;
}

/** Text für die Oberfläche. */
export function dnsHostLabel(recordName: string, domain: string): string {
  return dnsHost(recordName, domain) ?? "leer lassen oder @";
}

function normalize(value: string): string {
  return value.trim().toLowerCase().replace(/\.$/, "");
}

/** Was die Prüfung tatsächlich im DNS gefunden hat, damit Tippfehler oder Anführungszeichen auffallen. */
export function foundLabel(actual: readonly string[]): string {
  return actual.length === 0 ? "Gefunden: noch nichts (Eintrag fehlt oder ist noch nicht sichtbar)" : `Gefunden: ${actual.join(" | ")}`;
}

/** Kurze Rückmeldung nach „Jetzt testen“, damit klar ist, dass geprüft wurde. */
export function dnsCheckSummary(result: { checks: readonly { valid: boolean }[] }, now: Date = new Date()): string {
  const passed = result.checks.filter((entry) => entry.valid).length;
  const time = now.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  return `Geprüft um ${time}: ${passed} von ${result.checks.length} Einträgen passen. Neue Einträge können je nach Anbieter bis zu einer Stunde brauchen, bis sie sichtbar sind.`;
}
